import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Sun, Droplets, BookOpen, Activity, Moon, ClipboardList } from 'lucide-react';
export const SolutionSection = () => {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-sage" data-id="element-174" />,
    title: 'El PDF Interactivo',
    desc: '"Plan de 21 Días de Vitalidad Menopáusica".'
  }, {
    icon: <Sun className="w-6 h-6 text-sage" data-id="element-175" />,
    title: 'El Protocolo L.A.S.',
    desc: '(Luz-Agua-Sal) para mañanas sin neblina mental.'
  }, {
    icon: <Droplets className="w-6 h-6 text-sage" data-id="element-176" />,
    title: 'Matriz de Nutrición',
    desc: 'De Combustión Lenta para evitar bajones post-almuerzo.'
  }, {
    icon: <Activity className="w-6 h-6 text-sage" data-id="element-177" />,
    title: 'Guía de Movimiento Inteligente',
    desc: '15 minutos para proteger tus huesos y músculos.'
  }, {
    icon: <Moon className="w-6 h-6 text-sage" data-id="element-178" />,
    title: 'Checklist de Higiene del Sueño 50+',
    desc: 'Para dormir (y descansar) de verdad.'
  }, {
    icon: <ClipboardList className="w-6 h-6 text-sage" data-id="element-179" />,
    title: 'Diario de Auditoría de Energía',
    desc: 'Para identificar tus ladrones de vitalidad.'
  }];
  return <>
      <Section bg="bg-sage-light/30" data-id="element-180">
        <FadeIn data-id="element-181">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-182">
            <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-183">
              El Mecanismo Único
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-184">
              La Micro-Sincronización Hormonal
            </h2>
            <p className="text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-185">
              Un sistema diseñado específicamente para la biología de la mujer
              50+. No se trata de cambios radicales, sino de ajustar el momento
              exacto en que le das a tu cuerpo luz, agua, sal y nutrientes.
            </p>
            <p className="text-lg md:text-xl text-brown font-medium mt-6" data-id="element-186">
              Al alinear estos pequeños impulsos con tu ritmo circadiano,
              "reseteas" tus glándulas suprarrenales y permites que tu energía
              fluya de forma natural, sin depender de estimulantes.
            </p>
          </div>
        </FadeIn>
      </Section>

      <Section bg="bg-white" data-id="element-187">
        <FadeIn data-id="element-188">
          <div className="text-center mb-16" data-id="element-189">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-190">
              Lo que obtienes hoy
            </h2>
            <p className="text-brown-light" data-id="element-191">
              Todo lo que necesitas para implementar el método desde mañana
              mismo.
            </p>
          </div>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-192">
          {deliverables.map((item, index) => <StaggerItem key={index} data-id="element-193">
              <div className="bg-cream-light p-8 rounded-2xl h-full border border-cream-dark hover:shadow-md transition-shadow" data-id="element-194">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-195">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-196">{item.title}</h3>
                <p className="text-brown-light" data-id="element-197">{item.desc}</p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </Section>
    </>;
};